import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StreakStateService } from 'src/app/shared/services/streak-state.service';
import { WheelSegment } from 'src/app/shared/models/wheel.types';

// TODO: on 'wheel' page reload, the wheel is fetched twice, once here and once in app component.
// for home page, the wheel needs to load in the background, while on 'wheel' page it needs to load in a blocking manner.
export const wheelResolver: ResolveFn<WheelSegment[]> = (): Observable<WheelSegment[]> => {
  const state = inject(StreakStateService);

  if (state.wheelLoaded()) {
    return of(state.wheelSegments());
  }

  return state.loadWheelSegments();
};
